import React from "react";
import { Link } from "react-router-dom";
import styles from "./FooterNav.less";

const FooterNav = (props) => (
  <div className="col-md-12" id="footer-nav">
    <div id="footer-contents">
      <ul id="footer-menu">
        <li>
          <Link to="/">Today</Link>
        </li>
        <li>
          <Link to="/recent">Recent</Link>
        </li>
        <li>
          <Link to="/thisday">This Day</Link>
        </li>
        <li>
          <Link to="/search">Search</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
      </ul>
    </div>
  </div>
);

export default FooterNav;
